import { useState } from 'react';

export const useSwimlaneModelState = (initialNodes) => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const [title, Settitle] = useState('');
  const [ParentPageGroupId, SetParentPageGroupId] = useState(null);
  const [showPublishPopup, setShowPublishPopup] = useState(false);
  const [showEditorialPopup, setShowEditorialPopup] = useState(false);
  const [showContentPopup, setShowContentPopup] = useState(false);
  const [user, setUser] = useState(null);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [options, setOptions] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isCheckboxPopupOpen, setIsCheckboxPopupOpen] = useState(false);
  const [LinknodeList, setLinknodeList] = useState([]);
  const [isexistingroleCheckboxPopupOpen, setIsexistingroleCheckboxPopupOpen] = useState(false);

  const [LinkexistingRole, setLinkexistingRole] = useState([]);

  const [selectedLinknodeIds, setSelectedLinknodeIds] = useState([]);
  const [selectedexistigrolenodeId, setSelectedexistingrolenodeId] = useState('');
  const [getDraftedDate, setDraftedDate] = useState('');
  const [KeepOldPosition, setKeepOldPosition] = useState(null);
  const [isFavorite, setIsFavorite] = useState(false);
  const [process_img, setprocess_img] = useState('');
  const [selectedTitle, setSelectedTitle] = useState('');
  const [showTranslationPopup, setShowTranslationPopup] = useState(false);
  const [translationDefaults, setTranslationDefaults] = useState({
    en: '',
    de: '',
    es: '',
  });

  const [selectedGroupId, setSelectedGroupId] = useState(null);
  const [ChildNodes, setChiledNodes] = useState([]);
  const [contextMenu, setContextMenu] = useState(null);
  const [MenuVisible, setMenuVisible] = useState(false);
  const [selectedNode, setSelectedNode] = useState(null);
  const [roleGroupEditData, setRoleGroupEditData] = useState(null);

  const [selectedNodeId, setSelectedNodeId] = useState(null);
  const [selectedNodefreetextId, setSelectedNodefreetextId] = useState(null);
  const [showVersionPopup, setShowVersionPopup] = useState(false);
  const [versionPopupPayload, setversionPopupPayload] = useState('');
  const [processDefaultlanguage_id, setprocessDefaultlanguage_id] = useState(null);
  const [OriginalDefaultlanguge_id, setOriginalDefaultlanguge_id] = useState(null);
  const [supportedLanguages, setSupportedLanguages] = useState([]);

  const [selectedEdge, setSelectedEdge] = useState(null);
  const [getPublishedDate, setgetPublishedDate] = useState('');
  const [revisionData, setrevisionData] = useState(null);
  const [detailschecking, setdetailschecking] = useState(null);
  const [nodes, setNodes] = useState(initialNodes?.nodes || []);
  const [searchQuery, setSearchQuery] = useState('');
  const [ExistingrolesearchQuery, setExistingrolesearchQuery] = useState('');

  const [checkpublish, Setcheckpublish] = useState();
  const [showRoleGroupModal, setShowRoleGroupModal] = useState(false);
  const [showAssignOwnerModal, setShowAssignOwnerModal] = useState(false);
  const [activeRoleForOwner, setActiveRoleForOwner] = useState(null);
  const [selectedEdgeInfoForFreeText, setSelectedEdgeInfoForFreeText] = useState(null);
  const [edges, setEdges] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalText, setModalText] = useState('');
  const [modalPosition, setModalPosition] = useState({ x: 0, y: 0 });

  return {
    windowSize,
    setWindowSize,
    title,
    Settitle,
    ParentPageGroupId,
    SetParentPageGroupId,
    showPublishPopup,
    setShowPublishPopup,
    showEditorialPopup,
    setShowEditorialPopup,
    showContentPopup,
    setShowContentPopup,
    user,
    setUser,
    position,
    setPosition,
    hasUnsavedChanges,
    setHasUnsavedChanges,
    options,
    setOptions,
    isPopupOpen,
    setIsPopupOpen,
    isCheckboxPopupOpen,
    setIsCheckboxPopupOpen,
    LinknodeList,
    setLinknodeList,
    isexistingroleCheckboxPopupOpen,
    setIsexistingroleCheckboxPopupOpen,
    LinkexistingRole,
    setLinkexistingRole,
    selectedLinknodeIds,
    setSelectedLinknodeIds,
    selectedexistigrolenodeId,
    setSelectedexistingrolenodeId,
    getDraftedDate,
    setDraftedDate,
    KeepOldPosition,
    setKeepOldPosition,
    isFavorite,
    setIsFavorite,
    process_img,
    setprocess_img,
    selectedTitle,
    setSelectedTitle,
    showTranslationPopup,
    setShowTranslationPopup,
    translationDefaults,
    setTranslationDefaults,
    selectedGroupId,
    setSelectedGroupId,
    ChildNodes,
    setChiledNodes,
    contextMenu,
    setContextMenu,
    MenuVisible,
    setMenuVisible,
    selectedNode,
    setSelectedNode,
    roleGroupEditData,
    setRoleGroupEditData,
    selectedNodeId,
    setSelectedNodeId,
    selectedNodefreetextId,
    setSelectedNodefreetextId,
    showVersionPopup,
    setShowVersionPopup,
    versionPopupPayload,
    setversionPopupPayload,
    processDefaultlanguage_id,
    setprocessDefaultlanguage_id,
    OriginalDefaultlanguge_id,
    setOriginalDefaultlanguge_id,
    supportedLanguages,
    setSupportedLanguages,
    selectedEdge,
    setSelectedEdge,
    getPublishedDate,
    setgetPublishedDate,
    revisionData,
    setrevisionData,
    detailschecking,
    setdetailschecking,
    nodes,
    setNodes,
    searchQuery,
    setSearchQuery,
    ExistingrolesearchQuery,
    setExistingrolesearchQuery,
    checkpublish,
    Setcheckpublish,
    showRoleGroupModal,
    setShowRoleGroupModal,
    showAssignOwnerModal,
    setShowAssignOwnerModal,
    activeRoleForOwner,
    setActiveRoleForOwner,
    selectedEdgeInfoForFreeText,
    setSelectedEdgeInfoForFreeText,
    edges,
    setEdges,
    isModalOpen,
    setIsModalOpen,
    modalText,
    setModalText,
    modalPosition,
    setModalPosition,
  };
};
